(function () {
  function fixRouteProtectionLabel() {
    document.querySelectorAll('.route-div label.pw-checkout-box-label:empty').forEach(function (label) {
      var forId = label.getAttribute('for');
      var input = forId && document.getElementById(forId);
      var text = (input && input.getAttribute('aria-label')) || 'Shipping Protection';
      var span = document.createElement('span');
      span.className = 'visually-hidden';
      span.textContent = text;
      label.appendChild(span);
    });
  }

  var observer = new MutationObserver(fixRouteProtectionLabel);
  observer.observe(document.body, { childList: true, subtree: true });
  fixRouteProtectionLabel();
})();
